export default __webpack_public_path__ + "static/media/illustration_quiz.2816c547.webp";